import { generateI18nSlug } from "./utils";
import { PortfolioNode } from "./portfolio";
import { LanguageMapItem } from "../../types";
const path = require("path");

export function generateBlogPagePath(node: any) {
  const frontmatter = node.childMarkdownRemark.frontmatter;
  const slug =
    typeof frontmatter.slug === "string"
      ? frontmatter.slug
      : path.basename(node.relativePath, path.extname(node.relativePath));
  // const pagePath = generateI18nSlug(slug, frontmatter.language);
  const pagePath = slug;
  return "blog/" + pagePath;
}
export function generatePortfolioPagePath(
  node: any,
  withLanguage: boolean = false
) {
  const frontmatter = node.childMdx.frontmatter;
  const slug =
    typeof frontmatter.slug === "string"
      ? frontmatter.slug
      : path.basename(node.relativePath, path.extname(node.relativePath));
  const pagePath = slug;
  // const pagePath = generateI18nSlug(slug, frontmatter.language);
  let pathPrefix = "realizacje";
  if (node.childMdx.frontmatter.language === "en") {
    if (withLanguage) {
      pathPrefix = "en/portfolio";
    } else {
      pathPrefix = "portfolio";
    }
  }
  return pathPrefix + "/" + pagePath;
}
export function generateRangePagePath(
  node: any,
  withLanguage: boolean = false
) {
  const frontmatter = node.childMdx.frontmatter;
  const slug =
    typeof frontmatter.slug === "string"
      ? frontmatter.slug
      : path.basename(node.relativePath, path.extname(node.relativePath));
  const pagePath = slug;
  // const pagePath = generateI18nSlug(slug, frontmatter.language);
  let pathPrefix = "";
  if (node.childMdx.frontmatter.language === "en") {
    if (withLanguage) {
      pathPrefix = "en";
    } else {
      pathPrefix = "";
    }
  }
  return pathPrefix + "/" + pagePath;
}
export function generatePortfolioListPath(
  index: number,
  language: string,
  withLanguage: boolean = false
) {
  let pathPrefix = "/realizacje";
  if (language === "en") {
    if (withLanguage) {
      pathPrefix = "/en/portfolio";
    } else {
      pathPrefix = "/en/portfolio";
    }
  }

  return index > 1 ? pathPrefix + "/" + index : pathPrefix;
}
export function generateRelatedPortfolio(
  currentNode: any,
  languageGroups: { language: string; nodes: any[] }[],
  items: string[]
) {
  const nodeLanguage = currentNode.childMdx.frontmatter.language;
  const frontmatter = currentNode.childMdx.frontmatter;
  const group = languageGroups.find(languageGroup => {
    return languageGroup.language === nodeLanguage;
  });
  if (!group) {
    return [];
  }
  const nodes = group.nodes;

  items = typeof items !== "undefined" && items != null ? items : [];

  //if set static_related on frontmatter
  if (Array.isArray(items) && items.length > 0) {
    let realtedItems = nodes
      .filter((node: PortfolioNode) => {
        return items.indexOf(node.childMdx.frontmatter.slug) >= 0;
      })
      .map((node: PortfolioNode) => {
        return {
          slug: node.childMdx.frontmatter.slug,
          title: node.childMdx.frontmatter.title,
          thumbnail: node.childMdx.frontmatter.thumbnail,
          language: node.childMdx.frontmatter.language,
          category: node.childMdx.frontmatter.category,
          url: generatePortfolioPagePath(node),
          short_description: node.childMdx.frontmatter.short_description,
        };
      });
    return realtedItems;
  }

  const similarNodes = nodes
    .filter(node => {
      return currentNode.relativePath !== node.relativePath;
    })
    .map(node => {
      const nodeCategories = Array.isArray(node.childMdx.frontmatter.category)
        ? node.childMdx.frontmatter.category
        : [];
      const currentCategories = Array.isArray(
        currentNode.childMdx.frontmatter.category
      )
        ? currentNode.childMdx.frontmatter.category
        : [];
      const score = currentCategories.reduce((acc: number, curr: string) => {
        if (nodeCategories.indexOf(curr) !== -1) {
          ++acc;
        }
        return acc;
      }, 0);
      return { score, node };
    });

  similarNodes.sort((a, b) => {
    return a.score - b.score;
  });
  return similarNodes
    .slice(0, 3)
    .map((similarNode: { score: number; node: any }) => {
      return {
        slug: similarNode.node.childMdx.frontmatter.slug,
        title: similarNode.node.childMdx.frontmatter.title,
        thumbnail: similarNode.node.childMdx.frontmatter.thumbnail,
        language: similarNode.node.childMdx.frontmatter.language,
        category: similarNode.node.childMdx.frontmatter.category,
        url: generatePortfolioPagePath(similarNode.node),
        short_description:
          similarNode.node.childMdx.frontmatter.short_description,
      };
    });
}

export interface PortfolioItemPageParams {
  path: string;
  component: string;
  context: {
    node: any;
    language: string;
    map: LanguageMapItem[];
  };
}
